module.exports = __webpack_public_path__ + "media/images/marker-bottom-35f9a703.svg";